import { __ANY_PAGE } from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
import { makeOperator } from './Operator';
import isNumber from 'transmute/isNumber';
import isString from 'transmute/isString';
export default makeOperator({
  isRefinable: true,
  isRefinableExtra: true,
  name: 'FormNotFilledOut',
  values: [{
    defaultValue: __ANY_PAGE,
    name: 'value',
    isValid: v => isNumber(v) || isString(v)
  }, {
    defaultValue: false,
    name: 'isPageSelected'
  }]
});